var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.opts.data)?_c('select',{ref:"select",staticClass:"ui-select"},[_vm._t("default")],2):_c('input',{ref:"select",staticClass:"ui-select",attrs:{"type":"text"}})}
var staticRenderFns = []

export { render, staticRenderFns }